// translate an extglob into a regular expression

// call into this when we get a [!?@+] followed by (
// Walk down until we find the appropriate closing ),
// and parse all the sections.


export {}
